/**
 * An object containing card action properties
 */
var CardAction = /** @class */ (function () {
    function CardAction() {
    }
    return CardAction;
}());
export { CardAction };
//# sourceMappingURL=card-action.js.map